const context = __CLIENT__ ? window.__data?.context ?? {} : {};

export default context;
export function getContextByName(name: string) {
  return context[name];
}
